import increment from "./increment";
import decrement from "./decrement";
//import disconnect from './disconnect';

export default [
  increment,
  decrement,
  //disconnect,
];
